var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgOsSolaris(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.233 9.043c-4.656-.201-8.863.365-10.352 1.392-1.488 1.025 3.333 1.859 6.486 1.923 0 0 .09-.004.061.02-.019.017-.105.013-.105.013a75 75 0 0 1-2.467-.006c-6.19-.127-10.014-1.054-8.54-2.071 1.474-1.015 7.511-1.792 13.47-1.521 2.03.093 3.001.317 1.447.25M4.684 7.36s-.465.559-.377 1.228L.577 6.504zm1.055-1.062s-.671.364-.952.86L2.649 3.462l3.09 2.837Zm1.591-.252s-.696-.101-1.27.146L6.22 2zm1.508.676s-.444-.503-1.137-.583l2.461-3.397zm.83 1.364s-.13-.66-.674-1.085l3.86-1.642z",
    clipRule: "evenodd"
  })));
});